import {
  ADVICE_PRICE_STEP,
  ADVICE_YOUR_LIFE_SITUATION_STEP,
} from "Components/Features/CheckPrice/Products/Advice";
import {
  getEducation,
  getWorkStatus,
} from "Store/advice/productPriceRequestMappers/disabilityPriceRequestMapper";

import { AdviceProductDetailsFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductDetails/FormElements/interfaces";
import { AdvicePriceFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductPrice/AdviceCards/interfaces";
import { mapHasEmployerPaidDisabilityInsurance } from "Store/akaAdvice/mappers/utils";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";

export type DisabilityProductBackend = {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: any;
  customerRef: string;
  dateOfBirth: string;
  education?: string;
  hasEmployerPaidDisabilityInsurance: boolean;
  coverageAmountCapital: number | null;
  insuredSum: number;
  paymentAfter3Months: boolean;
  workStatus?: string;
  yearlyIncome: number;
  isFemale: boolean;
  isScandinavianCitizen: boolean;
  isSmoker: boolean;
  isStayingInNorwayForMoreThanFiveYears: boolean;
};

export function mapToCommerceDisability(data: {
  [key: string]: any;
}): DisabilityProductBackend {
  const formValues = data.formData;
  const adviceDetailsFormValues = formValues[
    ADVICE_YOUR_LIFE_SITUATION_STEP.id
  ] as AdviceProductDetailsFormValues;

  const paymentAfter3Months =
    (formValues[ADVICE_PRICE_STEP.id] as AdvicePriceFormValues)
      ?.disabilityPaymentAfter3Months === BooleanFormType.TRUE;

  return {
    name: INSURANCE_NAME_VALUE.DISABILITY_FLEX,
    coverageGroup: data.coverage,
    customerRef: data.customerData.newCustomerResponse.customerRef,
    dateOfBirth: data.customerData.newCustomerResponse.dateOfBirth,
    education: getEducation(adviceDetailsFormValues.education),
    hasEmployerPaidDisabilityInsurance: mapHasEmployerPaidDisabilityInsurance(
      adviceDetailsFormValues,
    ),
    coverageAmountCapital: data.oneTimePayment,
    insuredSum: data.insuredSum,
    paymentAfter3Months,
    workStatus: getWorkStatus(adviceDetailsFormValues.workSituation),
    yearlyIncome: adviceDetailsFormValues.income,
    isFemale: data.customerData.newCustomerResponse.isFemale,
    isScandinavianCitizen: true,
    isSmoker: false,
    isStayingInNorwayForMoreThanFiveYears: true,
  };
}
